import React from 'react'
import { Select } from 'antd'

function TicketCannedResponses(props) {
    const { Option } = Select

    const FILTER_COURSE_ACTIVATION = 'FILTER_COURSE_ACTIVATION'
    const FILTER_APP_ERROR = 'FILTER_APP_ERROR'
    const FILTER_NO_APP_FOR_PC = 'FILTER_NO_APP_FOR_PC'
    const FILTER_PDF_NOTES_NOT_WORKING = 'FILTER_PDF_NOTES_NOT_WORKING'
    const FILTER_COURSE_VALIDITY = 'FILTER_COURSE_VALIDITY'
    const FILTER_HI = 'FILTER_HI'
    const FILTER_FORUMS = 'FILTER_FORUMS'
    const FILTER_BYTE_SIZE_DISCOUNT = 'FILTER_BYTE_SIZE_DISCOUNT'
    const FILTER_EXTENSION = 'FILTER_EXTENSION'
    const FILTER_INDIVIDUAL_MODULES = 'FILTER_INDIVIDUAL_MODULES'
    const FILTER_NOTES = 'FILTER_NOTES'
    const FILTER_FREE_COURSES = 'FILTER_FREE_COURSES'
    const FILTER_FREE_COURSES_DEMO = 'FILTER_FREE_COURSES_DEMO'
    const FILTER_HINDI = 'FILTER_HINDI'
    const FILTER_PLEASE_FOLLOW_DEVICE_POLICY =
        'FILTER_PLEASE_FOLLOW_DEVICE_POLICY'
    const FILTER_EXTENSION_DONE = 'FILTER_EXTENSION_DONE'
    const FILTER_CA_FOUNDATION = 'FILTER_CA_FOUNDATION'
    const FILTER_ICASH = 'FILTER_ICASH'
    const FILTER_RESPONSE_TIMINGS = 'FILTER_RESPONSE_TIMINGS'
    const FILTER_DOWNLOAD_VIDEOS = 'FILTER_DOWNLOAD_VIDEOS'
    const FILTER_CMA = 'FILTER_CMA'
    const FILTER_CA_INTER = 'FILTER_CA_INTER'
    const FILTER_EMI = 'FILTER_EMI'
    const FILTER_PAYMENT = 'FILTER_PAYMENT'
    const FILTER_ILLUSTRATION_ANSWERS = 'FILTER_ILLUSTRATION_ANSWERS'
    const FILTER_CA_INTER_AFTER_BCOM = 'FILTER_CA_INTER_AFTER_BCOM'
    const FILTER_PHONE = 'FILTER_PHONE'
    const FILTER_STUDY_PLANNER = 'FILTER_STUDY_PLANNER'
    const FILTER_CFA_MORE_INFO = 'FILTER_CFA_MORE_INFO'
    const FILTER_ACCA_KNOW_MORE = 'FILTER_ACCA_KNOW_MORE'
    const FILTER_COURSE = 'FILTER_COURSE'
    const FILTER_SUPPORT = 'FILTER_SUPPORT'
    const FILTER_NOT_ANSWERING = 'FILTER_NOT_ANSWERING'
    const FILTER_WILL_REACH_SHORTLY = 'FILTER_WILL_REACH_SHORTLY'
    const FILTER_ATTEMPT = 'FILTER_ATTEMPT'
    const FILTER_BROWSER_ISSUE = 'FILTER_BROWSER_ISSUE'

    const getSelectOptions = () => {
        var options = []
        options.push(getOption(FILTER_COURSE_ACTIVATION, 'Course Activation'))
        options.push(getOption(FILTER_APP_ERROR, 'App Error'))
        options.push(getOption(FILTER_NO_APP_FOR_PC, 'No App for PC'))
        options.push(
            getOption(FILTER_PDF_NOTES_NOT_WORKING, 'PDF Notes Not Working')
        )
        options.push(getOption(FILTER_COURSE_VALIDITY, 'Course Validity'))
        options.push(getOption(FILTER_HI, 'Hi'))
        options.push(getOption(FILTER_FORUMS, 'Forums'))
        options.push(getOption(FILTER_BYTE_SIZE_DISCOUNT, 'Byte Size Discount'))
        options.push(getOption(FILTER_EXTENSION, 'Extension'))
        options.push(getOption(FILTER_INDIVIDUAL_MODULES, 'Individual Modules'))
        options.push(getOption(FILTER_NOTES, 'Notes'))
        options.push(getOption(FILTER_FREE_COURSES, 'Free Courses'))
        options.push(getOption(FILTER_FREE_COURSES_DEMO, 'Free Courses Demo'))
        options.push(getOption(FILTER_HINDI, 'Hindi'))
        options.push(
            getOption(
                FILTER_PLEASE_FOLLOW_DEVICE_POLICY,
                'Please follow device policy'
            )
        )
        options.push(getOption(FILTER_EXTENSION_DONE, 'Extension Done'))
        options.push(getOption(FILTER_CA_FOUNDATION, 'CA Foundation'))
        options.push(getOption(FILTER_ICASH, 'iCash'))
        options.push(getOption(FILTER_RESPONSE_TIMINGS, 'Response Timings'))
        options.push(getOption(FILTER_DOWNLOAD_VIDEOS, 'Download Videos'))
        options.push(getOption(FILTER_CMA, 'CMA'))
        options.push(getOption(FILTER_CA_INTER, 'CA Inter'))
        options.push(getOption(FILTER_EMI, 'EMI'))
        options.push(getOption(FILTER_PAYMENT, 'Payment'))
        options.push(
            getOption(FILTER_ILLUSTRATION_ANSWERS, 'Illustrations Answers')
        )
        options.push(
            getOption(FILTER_CA_INTER_AFTER_BCOM, 'CA Inter After BCom')
        )
        options.push(getOption(FILTER_PHONE, 'Phone'))
        options.push(getOption(FILTER_STUDY_PLANNER, 'Study Planner'))
        options.push(getOption(FILTER_CFA_MORE_INFO, 'CFA More Info'))
        options.push(getOption(FILTER_ACCA_KNOW_MORE, 'ACCA Know More'))
        options.push(getOption(FILTER_COURSE, 'Course'))
        options.push(getOption(FILTER_SUPPORT, 'Support'))
        options.push(getOption(FILTER_NOT_ANSWERING, 'Not Answering'))
        options.push(getOption(FILTER_WILL_REACH_SHORTLY, 'Will Reach Shortly'))
        options.push(getOption(FILTER_ATTEMPT, 'Attempt'))
        options.push(getOption(FILTER_BROWSER_ISSUE, 'Browser Issue'))

        return options
    }

    const getOption = (value, text) => {
        return (
            <Option value={value} key={value}>
                {text}
            </Option>
        )
    }

    const onChange = (value) => {
        if (!props.onSelectCannedResponse) {
            return
        }

        var message = ''
        if (value === FILTER_COURSE_ACTIVATION) {
            message =
                '<p class="MsoNormal">Hi,</p>' +
                '<p class="MsoNormal">We have activated your course for now.</p>' +
                '<p class="MsoNormal">Please find below the detailed instructions on viewing our courses</p>' +
                '<p class="MsoNormal">Please use only one browser on one laptop. Please do not change the device or browser too (i.e if you are using Chrome, do not change to Mozilla or Edge - Also, do not watch in incognito mode - if you change to a different browser or use incognito mode, that will be counted as a device change) Also when you clear cache of the browser - do not delete site data. If you do it will be counted as a change of device.</p>' +
                '<p class="MsoNormal">On your phone - use our app 1FIN - if you do not have it please download the same by clicking here - <a href="https://1fin.in/1FIN" target="_blank" rel="noopener">https://1fin.in/1FIN</a></p>' +
                '<p class="MsoNormal">Do not change the phone or do not try to access the course on your browser on your phone - if you do, it will be treated as a change of device</p>' +
                '<p class="MsoNormal">You can continue to use 1 phone and 1 laptop to access the courses</p>' +
                '<p class="MsoNormal">Do reach out to us if you face any further issues</p>' +
                '<p class="MsoNormal">Thanks</p>' +
                '<p class="MsoNormal">Team IL</p>'
        } else if (value === FILTER_APP_ERROR) {
            message =
                '<p class="MsoNormal">Hi</p>' +
                '<p class="MsoNormal">If videos are not playing try the steps below</p>' +
                '<ol>' +
                '<li class="MsoNormal">Close all the apps</li>' +
                '<li class="MsoNormal">Android: Settings -&gt; Applications -&gt; 1FIN-&gt; Storage -&gt; Click on ' +
                "'Clear Storage'" +
                ' and ' +
                "'Clear Cache'" +
                '</li>' +
                '<li class="MsoNormal">Restart device</li>' +
                '<li class="MsoNormal">Open the 1FIN app and play the video&nbsp;</li>' +
                '</ol>' +
                '<p class="MsoNormal">If this also does not work please try the below troubleshooting steps, it usually works.&nbsp;</p>' +
                '<p class="MsoNormal">Also, note that the downloaded videos if any will get deleted in the process. &nbsp; &nbsp;</p>' +
                '<ol>' +
                '<li class="MsoNormal">Uninstall the app &nbsp; &nbsp;</li>' +
                '<li class="MsoNormal">Restart the phone (Important step, clears a lot of issues) &nbsp; &nbsp;</li>' +
                '<li class="MsoNormal">Install app &nbsp; &nbsp; &nbsp; &nbsp;</li>' +
                '</ol>' +
                '<p class="MsoNormal">Also, check if there are any OS updates available. &nbsp; &nbsp;</p>' +
                '<p class="MsoNormal">If this does not work, then please do the following 3 steps and share screenshots and videos with us by opening a support ticket at <a href="https://1fin.link/support" target="_blank" rel="noopener">https://1fin.link/support</a></p>' +
                '<ol>' +
                '<li class="MsoNormal">Visit <a href="https://www.speedtest.net" target="_blank" rel="noopener">https://www.speedtest.net</a> and take a screenshot of your internet speed and share it with us</li>' +
                '<li class="MsoNormal">Visit <a href="https://whatismyipaddress.com" target="_blank" rel="noopener">https://whatismyipaddress.com</a> and take a screenshot of your IP and send it to us&nbsp;</li>' +
                '<li class="MsoNormal">Take another phone and make a video recording (&lt;5 MB) of the error you are facing on your phone/laptop and share the video recording with us&nbsp;</li>' +
                '</ol>' +
                '<p class="MsoNormal">&nbsp;Once you share the above 3 we shall connect you with our Tech Team</p>'
        } else if (value === FILTER_NO_APP_FOR_PC) {
            message =
                '<p>The app is available on mobile/tab only and not on laptops.</p>' +
                '<p>Please download the app from <a href="https://1fin.in/1FIN" target="_blank" rel="noopener">https://1fin.in/1FIN</a> on your mobile/tablet to watch our course. For watching on a laptop / PC<span style="box-sizing: border-box; margin: 0px; padding: 0px;">, please visit&nbsp;<a href="https://www.indigolearn.com" target="_blank" rel="noopener">https://www.indigolearn.com</a> and log in using the same ID you use</span>&nbsp;on the app.</p>'
        } else if (value === FILTER_PDF_NOTES_NOT_WORKING) {
            message =
                '<p>Are you able to open any PDF files on your device?</p>' +
                '<p>If not, then it looks like the default app set to open the PDF file is not working. Please download the PDF viewer app and make it the default app to open PDF files and it will work.</p>' +
                '<p><a href="https://play.google.com/store/apps/details?id=com.adobe.reader" target="_blank" rel="noopener">https://play.google.com/store/apps/details?id=com.adobe.reader</a></p>' +
                '<p>If this does not work, then please download on your pc browser</p>'
        } else if (value === FILTER_COURSE_VALIDITY) {
            message =
                '<p>Course is valid till the last day of the exam of the attempt for which you have purchased.</p>'
        } else if (value === FILTER_HI) {
            message = '<p>Hi,</p><p>How can we help you?</p>'
        } else if (value === FILTER_FORUMS) {
            message =
                '<p>Please post all the Subject related questions in forums on the app/website (Link below). This channel is for sales/support and related aspects.</p>' +
                '<p><a href="https://1fin.link/forums" target="_blank" rel="noopener">https://1fin.link/forums</a></p>'
        } else if (value === FILTER_BYTE_SIZE_DISCOUNT) {
            message =
                '<p>Regret that no discounts are allowed on individual modules. You can use only iCash balance if you have any.</p>'
        } else if (value === FILTER_EXTENSION) {
            message =
                '<p>We shall extend courses from the current attempt to the next attempt only after the exams conclude. The cost of an extension could be anywhere between 40-50% of course fees.&nbsp;</p>' +
                '<p>Please reach out to us after the exams</p>'
        } else if (value === FILTER_INDIVIDUAL_MODULES) {
            message =
                '<p>Individual chapter-wise modules are not being sold now.</p>'
        } else if (value === FILTER_NOTES) {
            message =
                '<p>Our notes are available for download on our app/website in the free notes &amp; resources section.</p>' +
                '<p>Please click here to access the same.</p>' +
                '<p><a href="https://1fin.link/free_resources" target="_blank" rel="noopener">https://1fin.link/free_resources</a></p>'
        } else if (value === FILTER_FREE_COURSES) {
            message =
                '<p>We have all subjects covered in full, but regret to let you know that they are paid courses and not free of cost.</p>' +
                '<p>We have roughly 3-5% of each subject as free. These are part of free courses and get added to your profile when you sign up on our app/website.</p>' +
                '<p><a href="https://1fin.link/free_courses" target="_blank" rel="noopener">https://1fin.link/free_courses</a></p>'
        } else if (value === FILTER_FREE_COURSES_DEMO) {
            message =
                '<p>Our free courses are 5-10% of the full syllabus - they are designed to give you an experience of our full course - you can go through them and then make a course purchase. You cannot use them alone to prepare for the exam.</p>' +
                '<p><a href="https://1fin.link/free_courses" target="_blank" rel="noopener">https://1fin.link/free_courses</a></p>'
        } else if (value === FILTER_HINDI) {
            message =
                '<p>We teach in simple English - exams are in English and your post-qualification job interview / eventual job will also be in English. According to us, CA course preparation is the right time for one to change to English to improve the grasp of the English language and communication skills.</p>' +
                '<p>Have a look at our demos and then take a call if you can understand what we are teaching. However, regret to inform you that we do not have courses in Hindi as of now and we are not sure if we will launch any course in Hindi even in the next 2 years.</p>'
        } else if (value === FILTER_PLEASE_FOLLOW_DEVICE_POLICY) {
            message =
                '<p>Please follow the device policy to ensure a disruption-free learning experience</p>'
        } else if (value === FILTER_EXTENSION_DONE) {
            message =
                '<p>Extension done. But please do not seek another extension.</p>'
        } else if (value === FILTER_CA_FOUNDATION) {
            message =
                '<p>Please check the links below:</p>' +
                '<p>CA Foundation guide</p>' +
                '<p><a href="https://1fin.link/exam/CA-Foundation-Course-A-Complete-Guide" target="_blank" rel="noopener">https://1fin.link/exam/CA-Foundation-Course-A-Complete-Guide</a></p>' +
                '<p><a href="https://1fin.link/exam/CA-Course-Guide-Here-Is-How-To-Become-a-CA" target="_blank" rel="noopener">https://1fin.link/exam/CA-Course-Guide-Here-Is-How-To-Become-a-CA</a></p>' +
                '<p>&nbsp;</p>' +
                '<p>Full CA Course, how to buy our course &amp; how to study &nbsp;</p>' +
                '<p><a href="https://1fin.link/courses/ochpmw" target="_blank" rel="noopener">https://1fin.link/courses/ochpmw</a></p>' +
                '<p><a href="https://1fin.link/resource/fedfd7d5443145da9a35b5154f147994" target="_blank" rel="noopener">https://1fin.link/resource/fedfd7d5443145da9a35b5154f147994</a></p>' +
                '<p>&nbsp;</p>'
        } else if (value === FILTER_ICASH) {
            message =
                '<p>Unfortunately, iCash cannot be used to buy mock tests/mentorship courses/ books or pay for extensions. iCash is a sort of discount - we are charging money for extensions/mocks mentorship to cover our costs. If we permit the usage of iCash, we will not get any money to meet our tech and related expenses.</p>'
        } else if (value === FILTER_RESPONSE_TIMINGS) {
            message =
                '<p>We are available for any queries from 10 AM to 6 PM on weekdays - during other times our response times will be delayed.</p>'
        } else if (value === FILTER_DOWNLOAD_VIDEOS) {
            message =
                '<p>For the first 3-5 seconds be connected to the Internet even if it is 3G or 2G does not matter. Some data validation takes place. Once that is done you can fully go offline</p>' +
                '<p>You can be connected to the Internet throughout and play downloaded video. Bandwidth will be consumed only for the first 3-5 seconds for data exchange. The video will play from the downloaded version and not the online version.</p>'
        } else if (value === FILTER_CMA) {
            message =
                '<p>You can check more about CMA here&nbsp;</p>' +
                '<p><a href="https://1fin.link/exam/CMA-Course-A-Complete-Guide" target="_blank" rel="noopener">https://1fin.link/exam/CMA-Course-A-Complete-Guide</a></p>' +
                '<p>&nbsp;</p>' +
                '<p>You can check our CMA courses here</p>' +
                '<p>CMA Foundation -&nbsp;<a href="https://1fin.link/courses/dekgcp" target="_blank" rel="noopener">https://1fin.link/courses/dekgcp</a></p>' +
                '<p>CMA Inter - <a href="https://1fin.link/courses/mkmpig" target="_blank" rel="noopener">https://1fin.link/courses/mkmpig</a></p>' +
                '<p>CMA Final - <a href="https://1fin.link/courses/rwuill" target="_blank" rel="noopener">https://1fin.link/courses/rwuill</a></p>'
        } else if (value === FILTER_CA_INTER) {
            message =
                '<p>To learn more about CA Inter click the link below</p>' +
                '<p><a href="https://1fin.link/exam/CA-Inter-A-Complete-Guide" target="_blank" rel="noopener">https://1fin.link/exam/CA-Inter-A-Complete-Guide</a></p>' +
                '<p><br>To buy our courses for CA Inter click the link below</p>' +
                '<p><a href="https://1fin.link/courses/rvdlwz" target="_blank" rel="noopener">https://1fin.link/courses/rvdlwz</a></p>'
        } else if (value === FILTER_EMI) {
            message = '<p>EMI is possible if you have credit card</p>'
        } else if (value === FILTER_PAYMENT) {
            message =
                '<p>We have not yet received the payment.</p>' +
                '<p>This happens sometimes when your account is debited and we do not receive the money.</p>' +
                '<p>It happens with Gpay / Rupay payments - please wait for 2 days and the matter will be resolved. Either you will get the money back or we will get the money and the course will be auto-activated - do not worry.</p>' +
                '<p>Please raise a complaint with your payment provider</p>'
        } else if (value === FILTER_ILLUSTRATION_ANSWERS) {
            message =
                '<p>Answers for illustrations in free notes are available in videos - you will be able to access them only when you buy our courses</p>'
        } else if (value === FILTER_CA_INTER_AFTER_BCOM) {
            message =
                '<p>Please check the links below for the Full CA Course, how to buy our course &amp; how to study</p>' +
                '<p><a href="https://1fin.link/exam/CA-Course-Guide-Here-Is-How-To-Become-a-CA" target="_blank" rel="noopener">https://1fin.link/exam/CA-Course-Guide-Here-Is-How-To-Become-a-CA</a></p>' +
                '<p><a href="https://1fin.link/courses/rvdlwz" target="_blank" rel="noopener">https://1fin.link/courses/rvdlwz</a></p>'
        } else if (value === FILTER_PHONE) {
            message =
                '<p>Please share your phone number so that our team can call you tomorrow</p>'
        } else if (value === FILTER_STUDY_PLANNER) {
            message =
                '<p>The study planner can be accessed here:</p>' +
                '<p><a href="https://1fin.link/study_planner" target="_blank" rel="noopener">https://1fin.link/study_planner</a></p>'
        } else if (value === FILTER_CFA_MORE_INFO) {
            message =
                '<p>To learn more about CFA click the link below:</p>' +
                '<p><a href="https://1fin.link/exam/CFA-Chartered-Financial-Analyst" target="_blank" rel="noopener">https://1fin.link/exam/CFA-Chartered-Financial-Analyst</a></p>'
        } else if (value === FILTER_ACCA_KNOW_MORE) {
            message =
                '<p>To learn more about ACCA click the link below:</p>' +
                '<p><a href="https://1fin.link/exam/ACCA-A-Comprehensive-course-guide" target="_blank" rel="noopener">https://1fin.link/exam/ACCA-A-Comprehensive-course-guide</a></p>'
        } else if (value === FILTER_COURSE) {
            message =
                '<p>We provide coaching for CA, CMA India, ACCA &amp; CFA. Please let us know which courses you are interested in.</p>'
        } else if (value === FILTER_SUPPORT) {
            message =
                '<p>Requesting you to raise a ticket here:</p>' +
                '<p><a href="https://1fin.link/support" target="_blank" rel="noopener">https://1fin.link/support</a></p>'
        } else if (value === FILTER_NOT_ANSWERING) {
            message =
                '<p>Our team tried reaching you but couldn' +
                "'t connect. Kindly reach us back on <a href=" +
                '"tel:919640111110" target="_blank" rel="noopener">9640-11111-0</a></p>'
        } else if (value === FILTER_WILL_REACH_SHORTLY) {
            message = '<p>Our team will reach you shortly</p>'
        } else if (value === FILTER_ATTEMPT) {
            message = '<p>Which level and attempt?</p>'
        } else if (value === FILTER_BROWSER_ISSUE) {
            message =
                '<p>Please clear the browser cache and try, it should work fine, steps below:</p>' +
                '<ul>' +
                '<li><a href="chrome://settings/" target="_blank" rel="noopener">chrome://settings/</a></li>' +
                '<li>Search for "clear browsing data"</li>' +
                '<li>Select the "clear browsing data" option present at the end</li>' +
                '<li>Advanced</li>' +
                '<li>Select the time range as "All time"</li>' +
                '<li>Select "Cookies and other site data" &amp; "Cached images and files"</li>' +
                '<li>Then log in to <a href="https://www.indigolearn.com" target="_blank" rel="noopener">https://www.indigolearn.com</a> and see if it works</li>' +
                '</ul>'
        }

        props.onSelectCannedResponse(message)
    }

    return (
        <Select
            placeholder="Canned Responses"
            showSearch
            allowClear={true}
            filterOption={(input, option) =>
                option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 300 }}
            onChange={onChange}
        >
            {getSelectOptions()}
        </Select>
    )
}

export default TicketCannedResponses
